module.exports = __webpack_public_path__ + "6fd1cc9890bfc221ce9f21c8973bca1c.png";